import { apiGateway } from '../api';

async function salvarArquivo(body) {
    try {
        const response = await apiGateway.post('/arquivo', body);
        return response.status;
    } catch (error) {
        return error;
    }
}

async function buscarArquivo(dadosBusca) {
    try {
        const response = await apiGateway.post('/arquivo/consulta', dadosBusca);
        return response.data || [];
    } catch (error) {
        return error;
    }
}

async function removerArquivo(body) {
    try {
        const response = await apiGateway.delete('/arquivo', { data: body });
        return response.status;
    } catch (error) {
        return error;
    }
}

export { salvarArquivo, buscarArquivo, removerArquivo };
